<template>
  <div v-if="hasVideos">
    <div
      class="mode"
      :title="modeTitle"
      :style="`background-color: ${modeColor}`"
      @click.stop.prevent="toggleMode()"
    >
      <b-icon :icon="playingMode" />
    </div>
    <div class="controls">
      <div class="previous" title="Previous" @click.stop.prevent="previous()">
        <b-icon icon="skip-backward" />
      </div>
      <div
        class="play"
        :title="!videoIsPlaying ? 'Play' : 'Stop'"
        @click.stop.prevent="!videoIsPlaying ? play() : stop()"
      >
        <b-icon :icon="!videoIsPlaying ? 'play' : 'stop'" />
      </div>
      <div class="next" title="Next" @click.stop.prevent="next()">
        <b-icon icon="skip-forward" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "controls",
  props: {
    posts: {
      type: Array,
      default: null
    }
  },
  computed: {
    ...mapGetters(["playingPost", "playingMode"]),
    modeColor() {
      switch (this.playingMode) {
        case "playlist-play":
          return "#00cec9";
        case "replay":
          return "#fd79a8";
        case "close":
          return "#fdcb6e";
        default:
          return "#00cec9";
      }
    },
    modeTitle() {
      switch (this.playingMode) {
        case "playlist-play":
          return "Playlist play mode";
        case "replay":
          return "Replay mode";
        case "close":
          return "No mode";
        default:
          return "Playlist play mode";
      }
    }
  },
  watch: {
    playingPost: "chagePlayingPost",
    posts: "changePinwallPosts"
  },
  data: () => {
    return {
      hasVideos: false,
      videoIsPlaying: false,
      index: 0,
      mobileWidth: process.env.VUE_APP_MOBILE_WIDTH,
      modes: ["playlist-play", "replay", "close"]
    };
  },
  methods: {
    ...mapMutations([
      "setPlayingPost",
      "setUserClickedOnMedia",
      "setPlayingMode"
    ]),
    stop() {
      this.posts.map(item => {
        item.playMedia = false;
      });
      this.setPlayingPost(null);
      this.setUserClickedOnMedia(false);
    },
    toggleMode() {
      let index = this.modes.findIndex(mode => {
        return mode === this.playingMode;
      });

      index = index < 2 ? (index += 1) : 0;
      this.setPlayingMode(this.modes[index]);
    },
    play() {
      let posts = this.posts;
      posts.map(item => {
        item.playMedia = false;
      });
      this.index = this.index > posts.length - 1 ? 0 : this.index;
      for (this.index; this.index < posts.length; this.index++) {
        const newPost = posts[this.index];
        if (newPost.video || newPost.audio) {
          newPost.playMedia = true;
          this.setUserClickedOnMedia(true);
          this.setPlayingPost(newPost);
          var element = document.getElementById(newPost.id);
          if (!this.isInViewport(element)) {
            element.scrollIntoView({ block: "center", behavior: "smooth" });
          }
          return;
        }
      }
    },
    previous() {
      //get previous post
      let posts = this.posts;
      let index = this.index - 1;
      index = index >= 0 ? index : posts.length - 1;
      let post = posts[index];
      if (post.video || post.audio) {
        this.index = index;
        this.play();
      } else {
        this.index = index;
        this.previous();
      }
    },
    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    next() {
      let posts = this.posts;
      let index = this.index + 1;
      index = index <= posts.length - 1 ? index : 0;
      let post = posts[index];
      if (post.video || post.audio) {
        this.index = index;
        this.play();
      } else {
        this.index = index;
        this.next();
      }
    },
    changePinwallPosts(newValue) {
      this.hasVideos = false;
      newValue.map(item => {
        if (!this.hasVideos) {
          if (item.video) {
            this.hasVideos = true;
          } else {
            this.hasVideos = false;
          }
        }
      });
    },
    chagePlayingPost(newValue) {
      if (newValue && newValue.playMedia) {
        this.index = newValue.i;
        this.videoIsPlaying = true;
      } else {
        this.videoIsPlaying = false;
      }
    }
  }
};
</script>
